import { render, staticRenderFns } from "./RoleDesign.vue?vue&type=template&id=d1964be6&scoped=true&"
import script from "./RoleDesign.vue?vue&type=script&lang=js&"
export * from "./RoleDesign.vue?vue&type=script&lang=js&"
import style0 from "./RoleDesign.vue?vue&type=style&index=0&id=d1964be6&scoped=true&lang=css&"
import style1 from "./RoleDesign.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1964be6",
  null
  
)

export default component.exports